<template>
  <el-drawer
    :visible.sync="visible"
    title="协作记录"
    append-to-body
    direction="rtl"
    :modal="false"
    custom-class="normal-drawer"
    @opened="fetchData"
    @closed="$emit('update:show', false)"
  >
    <div class="handle-history" v-loading="fetching">
      <div class="history-ul">
        <div
          class="history-li"
          :class="groupItem.isHide && 'is-hide'"
          v-for="groupItem in historyList"
          :key="groupItem.uniqueId"
        >
          <div class="history-date" @click="groupItem.isHide = !groupItem.isHide">
            <div class="date-icon-content">
              <i class="iconfont iconzhankai"></i>
            </div>
            <span>{{ groupItem.dateText }}</span>
          </div>
          <div class="history-info" v-for="item in groupItem.list" :key="item.id">
            <div class="history-user-info">
              <img class="user-avatar" :src="item.headimgurl" alt="" />
              <span>{{ item.name || item.nickname }}</span>
              <span class="handle-date">{{ item.createTime | dateFilter('HH:mm') }}</span>
            </div>
            <div class="history-hanlde-desc">
              <span>{{ item.action }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { uniqueId } from 'lodash';
import dayjs from 'dayjs';
import { services } from '@/service';

export default {
  data() {
    return {
      visible: false,
      fetching: false,
      historyList: []
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: String,
      required: true
    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      this.visible = true;
    });
  },
  methods: {
    async fetchData() {
      try {
        this.fetching = true;
        const result = await services.courseware.getTogetherRecord(this.courseId);
        this.historyList = this.formatHandle(result);
      } catch (err) {
        this.$error(err);
      } finally {
        this.fetching = false;
      }
    },
    formatHandle(list) {
      const arr = [];
      let preGroupItem = null;
      list.forEach(item => {
        const dateText = dayjs(item.createTime).format('YYYY-MM-DD');
        if (!preGroupItem || preGroupItem.dateText !== dateText) {
          preGroupItem = { uniqueId: uniqueId(), dateText, list: [], isHide: false };
          arr.push(preGroupItem);
        }
        preGroupItem.list.push(item);
      });
      return arr;
    }
  }
};
</script>

<style lang="scss" scoped>
.handle-history {
  .history-ul {
    .history-li {
      margin-bottom: 10px;

      .history-info {
        background-color: #f8fafd;
        border-radius: 4px;
        margin-top: 10px;
        padding: 15px;
        transition: all 0.2s;
        overflow: hidden;
        .history-user-info {
          font-size: 12px;
          line-height: 20px;
          color: #3d465a;

          & > span {
            vertical-align: super;
          }
          .user-avatar {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            overflow: hidden;
            background-color: #ccc;
            margin-right: 10px;
          }
          .handle-date {
            margin-left: 20px;
          }
        }
        .history-hanlde-desc {
          color: #2c3443;
          font-size: 14px;
          line-height: 20px;
          margin-top: 10px;
        }
      }

      .history-date {
        font-size: 12px;
        color: #9599a5;
        line-height: 24px;
        cursor: pointer;
        user-select: none;

        .date-icon-content {
          transition: all 0.2s;
          display: inline-block;
          margin-right: 6px;
          .iconfont {
            font-size: 12px;
          }
        }
      }
      &.is-hide {
        .date-icon-content {
          transform: rotate(-90deg);
        }
        .history-info {
          height: 0;
          padding: 0 15px;
          margin-top: 0;
        }
      }
    }
  }
}
</style>
